/** Display formatting. Amounts arrive as decimal strings; this is the only place they become numbers. */
const nf = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const intf = new Intl.NumberFormat("en-US");

/** Amounts arrive as decimal strings; formatting is the only place they become numbers. */
export const money = (value: string | number | undefined | null): string => {
  const n = Number(value ?? 0);
  const safe = Number.isFinite(n) ? n : 0;
  // Sign before the currency: "−$900.00", not "$-900.00".
  return `${safe < 0 ? "−" : ""}$${nf.format(Math.abs(safe))}`;
};

export const count = (value: number | string | undefined | null): string => intf.format(Number(value ?? 0));

export const pct = (value: string | number) => `${Number(value ?? 0)}%`;

export const shortDate = (iso: string) =>
  new Intl.DateTimeFormat("ru-RU", { day: "2-digit", month: "short" }).format(new Date(iso));

/** Elapsed time between two timestamps, in the coarsest unit that still reads. */
export const duration = (from: string, to: string): string => {
  const ms = new Date(to).getTime() - new Date(from).getTime();
  if (!Number.isFinite(ms) || ms < 0) return "—";
  if (ms < 1000) return `${ms} мс`;
  const secs = Math.round(ms / 1000);
  if (secs < 60) return `${secs} с`;
  const mins = Math.floor(secs / 60);
  return `${mins} мин ${secs % 60} с`;
};

export const dateTime = (iso: string | null) =>
  iso ? new Intl.DateTimeFormat("ru-RU", { dateStyle: "short", timeStyle: "short" }).format(new Date(iso)) : "—";
